import { formatMoney } from '@umbrella/utils';

class RcProductPrice extends HTMLElement {

  constructor() {
    super();
    this.event;
    this.currencySymbol = window.umbrellaConfig.currency.symbol || '£';
  };

  connectedCallback() { this.initialize(); };

  disconnectedCallback() { this.deinitialize(); };

  get priceElement() { return this.querySelector('[data-price]'); };
  
  get compareAtElement() { return this.querySelector('[data-compare-at-price]'); };
  get savePriceElement() { return this.querySelector('[data-save-price]'); };
  onVariantChange = (event) => {
    const variant = event.detail && event.detail.data;
    if(!variant) return;
    this.updatePrices(variant);
  };

  updatePrices(variant) {
    if(!variant) return;
    // Sale price
    const priceNode = this.priceElement;
    if(priceNode) {
      const price = `${formatMoney(variant.price)}`;
      priceNode.textContent = price;
    };
    // Save price
    const savePriceNode = this.savePriceElement;
    const savePrice = variant.compare_at_price - variant.price;
    if(savePriceNode && savePrice > 0) {
      savePriceNode.innerHTML = `${window.umbrellaConfig.addToCart.save} ${formatMoney(savePrice)}`;
    };
    // Compare at price
    const compareNode = this.compareAtElement;
    const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    if(compareNode && hasCompare) {
      const comparePrice = `${formatMoney(variant.compare_at_price)}`;
      compareNode.textContent = comparePrice;
    };
  };

  async initialize() {
    this.event = window.umbrellaConfig.events.variantChange;
    document.addEventListener(this.event, this.onVariantChange);
  };

  deinitialize() { document.removeEventListener(this.event, this.onVariantChange); };

};

if(!customElements.get('rc-product-price')) customElements.define('rc-product-price', RcProductPrice);